<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ld9cll/tc-custom/FC-9781528969123.jpg?1692134991114?1709061804364" alt="This image is the cover for the book Australia: Monarchy, Nature and Beyond"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Australia: Monarchy, Nature and Beyond
      </h1>
      <p class="bookDescription body article font2">
        <p>Using human nature, the laws of nature, our animal instincts and the invisible world of conventions and evolution to explain 'why' the Australian system works so well. We discuss reserve rights, head of state, the republican movement, the dismissal, appointing judges, appointing our governor general, the need for an independent speaker and appointing one, our party system - can it survive - and much more. This book questions ideological thinking and presents an intellectual challenge to the reader. If you want to know why Australians are who they are, and believe you can make the world a better place, then this book is for you.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Bruce Stephenson
      </h2>
      
      <p class="authorDescription body article">J Fitzmaurice was born and bred in Sydney, NSW, is 70 years young, happily married and living on a hobby farm managing sheep. After leaving school, he obtained a trade certificate in electronics and worked in this field for a number of years. Shortly after getting married, he and his wife moved to rural NSW to grow fine wool merino sheep. He has always had a passion for politics and physics and has tried to combine these two interests in this book. He respects and supports the current political system and the constitution but believes positive change is necessary and possible. Like most people, he is striving to improve the human condition for future generations. He hopes this can be done by fine tuning our political structure and explaining the virtues of our current system.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?69f93c3e